interface AppEnvironment {
    ROLLBAR_ACCESS_TOKEN?: string;
    NAME?: string;
    VERSION?: string;
}

export interface RollbarConfig {
    accessToken: string | undefined;
    environment: string | undefined;
    enabled: boolean;
    captureUncaught: boolean;
    captureUnhandledRejections: boolean;
    payload: {
        client: {
            javascript: {
                code_version: string | undefined;
            };
        };
    };
}

export const buildRollbarConfig = (environment: AppEnvironment | undefined): RollbarConfig => ({
    accessToken: environment?.ROLLBAR_ACCESS_TOKEN,
    environment: environment?.NAME,
    enabled: Boolean(environment?.ROLLBAR_ACCESS_TOKEN) && environment?.NAME !== 'local',
    captureUncaught: true,
    captureUnhandledRejections: true,
    payload: {
        client: {
            javascript: {
                code_version: environment?.VERSION,
            },
        },
    },
});
